import React from 'react'
import PropTypes from 'prop-types'
import { marginSizes } from 'theme/default'
import Flex from 'components/Flex'
import Button, { DefaultButtonText } from 'components/Button'

const IconButton = ({ Icon, children, ButtonText = DefaultButtonText, ...props }) => (
  <Button {...props}>
    {({ loading, LoadingElement }) => (
      loading
        ? LoadingElement
        : <React.Fragment>
          <Flex justifyContent='center' alignItems='center' marginRight={marginSizes.small}>
            <Icon fill='currentColor' />
          </Flex>
          <ButtonText>{children}</ButtonText>
        </React.Fragment>
    )}
  </Button>
)

IconButton.propTypes = {
  ...Button.propTypes,
  Icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
}

export default IconButton
